module.exports = __webpack_public_path__ + "img/inst-modal-11.52571a37.png";